const WalkInDetailsConfig = [
    {
        span: 8,
        height: "36px",
        classes: "marginTop-8",
    },
    {
        columns: [
            {
                classes: "marginTop-16",
                span: 6,
                height: "72px",
            },
            {
                classes: "marginTop-16",
                span: 2,
            },
        ],
    },
    {
        columns: [
            {
                classes: "marginTop-16 ",
                span: 6,
                height: "72px",
            },
            {
                classes: "marginTop-16",
                span: 2,
            },
        ],
    },
]

export default WalkInDetailsConfig
